<div class="hol-filter-panel" [class.deployed]="isDeployed">
  <div (click)="togglePanel()" class="action-button">
    <mat-icon>chevron_right</mat-icon>
  </div>
  <ng-content> </ng-content>
</div>
